import request from '@/common/js/request'

/**
 * 文章详情
 */
export const articleArticleIdGet = (option = {}) => {
    return request({
        url: '/apis/article/{articleId}',
        method: 'get',
        ...option
    })
}

/**
 * 文章列表
 */
export const articlesGet = (option = {}) => {
    return request({
        url: '/apis/articles',
        method: 'get',
        ...option
    })
}

/**
 * 文章标签列表
 */
export const articlesViewpointsGet = (option = {}) => {
    return request({
        url: '/apis/article/{articleId}/viewpoints',
        method: 'get',
        ...option
    })
}

/**
 * 文章标签列表
 */
export const articlesTagsGet = (option = {}) => {
    return request({
        url: '/apis/article/{articleId}/tags',
        method: 'get',
        ...option
    })
}

/**
 * 文章推荐列表
 */
export const recommendArticlesGet = (option = {}) => {
    return request({
        url: '/apis/recommend/articles',
        method: 'get',
        ...option
    })
}

export const articleRepliesGet = (option = {}) => {
    return request({
        url: '/apis/article/{articleId}/replies',
        method: 'get',
        ...option,
    })
}

